import { InternalChartToolbarConfigured } from '../../../types/toolbar.js';

export function getToolbarConfigWithoutIntents<
  T extends InternalChartToolbarConfigured,
>(configuredToolbar: T) {
  const { intents, collapsed, ...toolbar } = configuredToolbar;

  return toolbar;
}
